export default "__VITE_PUBLIC_ASSET__e354e786__"